import { __assign } from "tslib";
import React from 'react';
import ThumbHtmlView from './CommissionHtml';
import ThumbReactView from './Commission';
var CommissionThumbView = function (props) {
    if (props.isHtml) {
        return React.createElement(ThumbHtmlView, __assign({}, props));
    }
    return React.createElement(ThumbReactView, __assign({}, props));
};
CommissionThumbView.displayName = 'CommissionThumbView';
export default CommissionThumbView;
//# sourceMappingURL=index.js.map